{
  "longPressMessage": "Apăsați lung pentru a deschide previzualizarea"
}
